import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { combineLatest, Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { MSpot } from '../../domain/models/mspot.models';
import { ApiMspotService } from '../../infrastructure/services/api-mspot.service';

import { getCatalogId, getStoreAndLanguage } from '@core/infrastructure/state/core.selectors';
import { selectUserIsVip } from '@shared/user/store';

@Injectable()
export class MspotService {
    constructor(
        private readonly store: Store,
        private readonly apiMspotService: ApiMspotService,
    ) {}

    public getMspot(name: string): Observable<MSpot> {
        return combineLatest([
            this.store.select(getStoreAndLanguage),
            this.store.select(getCatalogId),
            this.store.select(selectUserIsVip),
        ]).pipe(
            switchMap(([storeAndLanguage, catalogId, userIsVip]) => {
                const userFlags = userIsVip ? 'vip' : '';

                return this.apiMspotService.getMspot(
                    storeAndLanguage.countryCode,
                    storeAndLanguage.languageCode,
                    catalogId,
                    name,
                    userFlags,
                );
            })
        );
    }
}
